<template>
  <div>
    <van-sticky>
      <van-nav-bar style="background-color: #3090ec">
        <template #left>
          <van-icon color="white" name="arrow-left" @click="getmodel('home')" />
        </template>

        <template #title>
          <span>我的发票</span>
        </template>

        <template #right>
          <van-icon
            color="white"
            name="goods-collect-o"
            @click="getmodel('addGoods')"
          >
            +
          </van-icon>
        </template>
      </van-nav-bar>
      <van-search v-model="searchSp" placeholder="请输入搜索关键词" />
    </van-sticky>
    <div class="list-content" id="list-content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="- 没有更多了 -"
          @load="onLoad"
          :offset="10"
        >
          <div class="list-item">
            <div
              role="button"
              :key="item.id"
              v-for="item in myList"
              tabindex="0"
              class="
                van-cell
                van-cell--clickable
                van-cell--center
                van-cell--borderless
                van-contact-card van-contact-card--edit
              "
            >
              <van-icon name="goods-collect-o" />

              <div
                class="
                  van-cell__value van-cell__value--alone
                  van-contact-card__value
                "
              >
                <div>发票日期：{{ item.addDate }}</div>
                <div>发票代码：{{ item.fpdm }}</div>
                <div>发票号码：{{ item.fphm }}</div>
                <div>发票状态：{{ parseJstatus(item.jstatus) }}</div>
                <div>发票类型：{{ parsefplx(item.fplxdm) }}</div>
              </div>
              <!-- <i class="van-icon van-cell__right-icon">666</i> -->
              <van-icon
                name="arrow"
                @click="getmodelParam('invoiceInfo', { id: item.id })"
              />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
 
<script>
import Vue from "vue";
import {cell, List, PullRefresh} from "vant";

Vue.use(List);
Vue.use(PullRefresh);
Vue.use(cell);
export default {
  data() {
    return {
      page: 1,
      loading: false, // 当loading为true时，转圈圈
      finished: false, // 数据是否请求结束，结束会先显示- 没有更多了 -
      myList: [],
      noData: false, // 如果没有数据，显示暂无数据
      isLoading: false, // 下拉的加载图案
      searchSp: "",
      totalPages: 0,
      jstatus: 1,
    };
  },
  methods: {
    getInfo() {
      let _this = this;
      let url = "/memberBusiness/invoice/" + this.page + "/10/inputinvoiceList";
      return new Promise((resolve, reject) => {
        _this.$axios
          .get(url, { jstatus: this.jstatus })
          .then((data) => {
            if (data.code == 200) {
              this.loading = false;
              this.myList = this.myList.concat(data.data.content);
              this.page++;
              // 如果没有数据，显示暂无数据
              if (this.myList.length === 0 && this.page === 1) {
                this.noData = true;
              }
              // 如果加载完毕，显示没有更多了
              if (this.page === data.data.totalPages) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    onLoad() {
      // 上拉
      setTimeout(() => {
        this.getInfo();
        this.loading = true;
      }, 500);
    },
    onRefresh() {
      //下拉刷新
      setTimeout(() => {
        // 重新初始化这些属性
        this.isLoading = false;
        this.myList = [];
        this.page = 1;
        this.loading = false;
        this.finished = false;
        this.noData = false;
        // 请求信息
        this.getInfo();
      }, 500);
    },
  },

  mounted() {
    let winHeight = document.documentElement.clientHeight; //视口大小
    document.getElementById("list-content").style.height =
      winHeight - 20 + "px"; //调整上拉加载框高度
  },
  created() {
    this.jstatus = this.$route.query.jstatus;
  },
};
</script>
 
<style scoped>
.list-content {
  margin-top: 46px;
  overflow: scroll;
}
.list-item {
  text-align: center;
}
</style>